
export const tableColumns = {
  experiments: [
    {
      text: 'Experiment System ID',
      value: 'system_id',
      model: 'bioModel'
    },
    {
      text: 'Projects',
      value: d => d.projects.map(p => p.pk).join(', ')
    },
    {
      text: 'Sequencing Data',
      value: d => d.sequencing_data.map(s => s.file_type).join(', ')
    },
    {
      text: 'Individual ID',
      value: 'sample.individual.research_id'
    },
    {
      text: 'Sample ID',
      value: 'sample.research_id'
    },
    {
      text: 'Experiment ID',
      value: 'research_id'
    },
    {
      text: 'Primary Key',
      value: 'pk'
    },
    {
      text: 'Individual System ID',
      value: 'sample.individual.system_id'
    },
    {
      text: 'Individual Institution',
      value: 'sample.individual.center'
    },
    {
      text: 'Individual Gender',
      value: 'sample.individual.gender'
    },
    {
      text: 'Individual Species',
      value: 'sample.individual.species'
    },
    {
      text: 'Individual Birth Year',
      value: 'sample.individual.birth_year'
    },
    {
      text: 'Sample System ID',
      value: 'sample.system_id'
    },
    {
      text: 'Sample Type',
      value: 'sample.source_type'
    }
  ],

  projects: [
    {
      text: 'Key',
      value: 'pk',
      sortable: true,
      model: 'project'
    },
    {
      text: 'Title',
      value: 'title',
      sortable: true
    },
    {
      id: 'method',
      text: 'Method',
      value: d => Object.keys(d.data.sequencing_methods).join(', '),
      sortable: false
    },
    {
      text: 'Principal Investigator',
      value: 'principal_investigator',
      sortable: true
    },
    {
      text: 'Owner',
      value: 'owner',
      sortable: true
    },
    {
      text: 'Analyst',
      value: 'analyist',
      sortable: true
    },
    {
      text: 'Coordinator',
      value: 'coordinator',
      sortable: true
    },
    {
      id: 'diseases',
      text: 'Diseases',
      value: d => Object.keys(d.data.diseases).join(', '),
      sortable: false
    },
    {
      text: 'Description',
      value: 'description',
      sortable: false
    },
    {
      text: 'Res Usage(TB)',
      value: 'data.res_usage',
      sortable: false
    },
    {
      text: 'Warm Usage(TB)',
      value: 'data.warm_usage',
      sortable: false
    },
    {
      text: 'Created Date',
      value: 'created',
      format: 'date',
      sortable: true
    },
    {
      text: 'Modified Date',
      value: 'modified',
      format: 'date',
      sortable: true
    },
    {
      text: 'Notes',
      value: 'notes',
      sortable: false
    },
    {
      id: 'tags',
      text: 'tags',
      value: d => d.tags.map(d => d.name).join(', '),
      sortable: false
    }
  ],

  analyses: [
    {
      text: 'Key',
      value: 'pk',
      sortable: true,
      model: 'analysis'
    },
    {
      text: 'Status',
      value: 'status',
      sortable: true
    },
    {
      text: 'Name',
      value: 'application.name',
      sortable: true
    },
    {
      text: 'Application',
      value: 'application.pk',
      sortable: true
    },
    {
      id: 'targets',
      text: 'Target Experiments',
      value: d => d.cached_fields.targets.map(target => target.system_id),
      sortable: false,
      model: 'bioModel'
    },
    {
      id: 'references',
      text: 'Reference Experiments',
      value: d => d.cached_fields.references.map(ref => ref.system_id),
      sortable: false,
      model: 'bioModel'
    },
    {
      text: 'Version',
      value: 'application.version',
      sortable: true
    },
    {
      id: 'analyses',
      text: 'Linked Analyses',
      value: d => d.analyses.join(' '),
      sortable: false
    },
    {
      id: 'projects',
      text: 'Projects',
      value: d => d.projects.map(p => p.pk).join(', '),
      sortable: false
    },
    {
      text: 'Created Date',
      value: 'created',
      format: 'date',
      sortable: true
    },
    {
      text: 'Modified Date',
      value: 'modified',
      format: 'date',
      sortable: true
    },
    {
      text: 'Notes',
      value: 'notes',
      sortable: false
    },
    {
      id: 'tags',
      text: 'tags',
      value: d => d.tags.map(d => d.name).join(', '),
      sortable: false
    }
  ],

  submissions: [
    {
      text: 'Primary Key',
      value: 'pk',
      sortable: true,
      model: 'submission'
    },
    {
      id: 'projects',
      text: 'Projects',
      value: d => d.projects.join(', '),
      model: 'project',
      sortable: true
    },
    {
      text: 'Processed',
      value: 'processed',
      format: 'date',
      sortable: true
    },
    {
      text: 'Created By',
      value: 'created_by',
      sortable: true
    },
    {
      text: 'Description',
      value: 'description',
      sortable: true
    },
    {
      text: 'Created Date',
      value: 'created',
      format: 'date',
      sortable: true
    },
    {
      text: 'Modified Date',
      value: 'modified',
      format: 'date',
      sortable: true
    },
    {
      text: 'Notes',
      value: 'notes',
      sortable: false
    },
    {
      text: 'tags',
      value: d => d.tags.map(d => d.name).join(', '),
      sortable: false
    }
  ],

  samples: [
    {
      text: 'System ID',
      value: 'system_id',
      sortable: true,
      model: 'bioModel'
    },
    {
      text: 'Primary Key',
      value: 'pk',
      sortable: true
    },
    {
      text: 'Sample ID',
      value: 'research_id',
      sortable: true
    },
    {
      text: 'Class',
      value: 'sample_class',
      sortable: true
    },
    // {
    //   text: 'Tissue',
    //   value: '',
    //   sortable: true
    // },
    {
      text: 'Disease',
      value: 'disease.name',
      sortable: true
    },
    // {
    //   text: 'Collection Year',
    //   value: '',
    //   sortable: true
    // },
    // {
    //   text: 'Tumor Class',
    //   value: 'Tumor Class',
    //   sortable: true
    // },
    // {
    //   text: 'Tissue Site',
    //   value: 'Tissue Site',
    //   sortable: true
    // },
    // {
    //   text: 'Therapy Time Point',
    //   value: 'Therapy Time Point',
    //   sortable: true
    // },
    {
      text: 'Is PDX',
      value: 'is_pdx',
      sortable: true
    },
    // {
    //   text: 'PDX ID',
    //   value: 'PDX ID',
    //   sortable: true
    // },
    // {
    //   text: 'PDX passage',
    //   value: 'PDX passage',
    //   sortable: true
    // },
    {
      text: 'Created Date',
      value: 'created',
      format: 'date',
      sortable: true
    },
    {
      text: 'Modified Date',
      value: 'modified',
      format: 'date',
      sortable: true
    },
    {
      text: 'Notes',
      value: 'notes',
      sortable: false
    },
    {
      id: 'tags',
      text: 'tags',
      value: d => d.tags.map(d => d.name).join(', '),
      sortable: false
    }
  ],

  individuals: [
    {
      text: 'System ID',
      value: 'system_id',
      sortable: true,
      model: 'bioModel'
    },
    {
      text: 'Individual ID',
      value: 'research_id',
      sortable: true
    },
    {
      text: 'Species',
      value: 'species',
      sortable: true
    },
    {
      text: 'Center',
      value: 'center.name',
      sortable: true
    },
    {
      text: 'Birth Year',
      value: 'birth_year',
      sortable: true
    },
    {
      text: 'Submission Form',
      value: 'submission',
      sortable: true,
      model: 'submission'
    },
    {
      text: 'Created Date',
      value: 'created',
      format: 'date',
      sortable: true
    },
    {
      text: 'Modified Date',
      value: 'modified',
      format: 'date',
      sortable: true
    },
    {
      text: 'Notes',
      value: 'Notes',
      sortable: false
    },
    {
      id: 'tags',
      text: 'tags',
      value: d => d.tags.map(d => d.name).join(', '),
      sortable: false
    }
  ]

}

export const viewFields = {
  individual: {
    'System ID': 'system_id',
    'Research ID': 'research_id',
    'Form': 'submission',
    'Species': 'species',
    'Gender': 'gender',
    'Birth Year': 'birth_year',
    'Institution': 'center.name',
    'Notes': 'notes',
    'Tags': d => d.tags.map(t => t.name)
  },

  sample: {
    'System ID': 'system_id',
    'Research ID': 'research_id',
    'Form': 'submission',
    'Source Type': 'sample_class',
    'Disease': 'disease.name',
    'Notes': 'notes',
    'Tags': d => d.tags.map(t => t.name)
  },

  experiment: {
    'System ID': 'system_id',
    'Research ID': 'research_id',
    'Form': 'submission',
    'Has Bam': 'hasbam',
    'Has Fastq': 'hasfastq',
    'Projects': d => d.projects.map(p => p.pk),
    'Notes': 'notes',
    'Tags': d => d.tags.map(t => t.name)
  },

  sequencing: {
    'Links': 'qc_report_url',
    'Center': 'sequencing_cente.namer',
    'Platform': 'sequencing_platform.name',
    'Method': 'technique.method',
    'Panel': 'technique.slug',
    'Read Length': 'read_length',
    'Read Type': 'read_type'
  }

}

export const defaultQueryParams = {
  analyses: {
    'fields!': 'targets,references'
  }
}
